import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PPMetricsCards from "../payrole-tabs/PPMetricsCards";
import PPPayrollStatsSection from "../payrole-tabs/PPPayrollStatsSection";
import { fetchGymOverviewDetailsStatsData } from "../../../redux/payrole-reducers/payroleSlice";

const Overview = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const {
    gymOverviewDetailsStatsData,
    gymOverviewDetailsStatsLoading,
    gymOverviewDetailsStatsError,
  } = useSelector((state) => state.payrole);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";
  const isManagerRole = ["fitness_manager", "sales_manager", "club_manager"].includes(userInfoData?.account_type);
  const isStaff =
    userInfoData?.account_type === "receptionist" ||
    userInfoData?.account_type === "trainer";

  const iniAllFilter = {
    selectedGym: !isAdmin && !isClusterManager && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    accountType: "",
    selectedMonth: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    user_id: isStaff ? userInfoData?.user_id || userInfoData?.uid || "" : "",
    gym_id: allFilters.selectedGym?.value || "",
    account_type: allFilters.accountType?.value || "",
    month: allFilters.selectedMonth?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);

  const iniStats = {
    allStats: {},
    allOtherStats: {},
  };
  const [statsData, setStatsData] = useState(iniStats);

  const getGymOverviewDetailsStats = (filters) => {
    dispatch(
      fetchGymOverviewDetailsStatsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getGymOverviewDetailsStats(filters);
  }, [filters]);

  useEffect(() => {
    if (
      !gymOverviewDetailsStatsLoading &&
      !gymOverviewDetailsStatsError &&
      gymOverviewDetailsStatsData?.status
    ) {
      const {
        employees_count,
        total_payout,
        total_deduction_sum,
        avg_attendance_day,
        ...otherStats
      } = gymOverviewDetailsStatsData?.data || {};

      setStatsData((prevs) => ({
        ...prevs,
        allStats: {
          employees_count,
          total_payout,
          total_deduction_sum,
          avg_attendance_day,
        },
        allOtherStats: gymOverviewDetailsStatsData?.data || {},
      }));
    } else {
      setStatsData(iniStats);
    }
  }, [
    gymOverviewDetailsStatsLoading,
    gymOverviewDetailsStatsError,
    gymOverviewDetailsStatsData,
  ]);

  return (
    <>
      <PPMetricsCards metrics={statsData.allStats} />

      <PPPayrollStatsSection statsData={statsData.allOtherStats} />
    </>
  );
};

export default Overview;
